import { Header } from './Header.jsx';
import { Footer } from './Footer.jsx';

export const Layout = ({ children, color = 'red' }) => (
  <div className="container">
    <Header />
    <div className="content">{children}</div>
    <Footer />
    <style jsx>{`
      .container {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
      }

      .content {
        flex-grow: 1;
      }
    `}</style>
  </div>
);
